import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  SectionContainer,
  SectionTitle,
  InputGroup,
  CurrencyInput,
  InputHelper,
  InputError,
  SaveButton,
  CancelButton,
  ButtonGroup,
  DueDate
} from './styles'

/** Reais → string de dígitos em centavos (evita lixo de ponto flutuante em value * 100). */
const reaisToInputDigits = reais => String(Math.round(Number(reais) * 100))

const formatCurrencyInput = value => {
  // Remove tudo que não é dígito
  const digits = value.replace(/\D/g, '')

  // Converte para número com centavos
  const number = parseInt(digits || '0') / 100

  // Formata para BRL
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(number)
}

const parseCurrencyToNumber = currencyString => {
  if (!currencyString) return 0
  // Remove R$, espaços e pontos, troca vírgula por ponto
  const cleaned = currencyString
    .replace(/R\$\s?/g, '')
    .replace(/\./g, '')
    .replace(',', '.')
  return parseFloat(cleaned) || 0
}

export const CustomEntrySection = ({
  onSave,
  onCancel,
  selectedEntry,
  minEntryValue,
  formattedDueDate,
  validationMessages
}) => {
  const [customEntryValue, setCustomEntryValue] = useState('')
  const [entryError, setEntryError] = useState('')

  const minEntry = minEntryValue || 100.0

  useEffect(() => {
    if (selectedEntry?.value != null) {
      setCustomEntryValue(formatCurrencyInput(reaisToInputDigits(selectedEntry.value)))
    }
  }, [selectedEntry])

  const handleEntryChange = e => {
    const formatted = formatCurrencyInput(e.target.value)
    setCustomEntryValue(formatted)
    setEntryError('')
  }

  const handleSaveEntry = () => {
    const numericValue = parseCurrencyToNumber(customEntryValue)

    if (numericValue < minEntry) {
      const errorMsg =
        validationMessages?.errorMessageMin ||
        `O valor da entrada não pode ser menor que ${formatCurrencyInput(reaisToInputDigits(minEntry))}`
      setEntryError(errorMsg)
      return
    }

    // Chama callback com valor numérico
    onSave(numericValue)
  }

  const handleCancel = () => {
    setCustomEntryValue('')
    setEntryError('')
    onCancel()
  }

  return (
    <SectionContainer>
      <SectionTitle>Entrada</SectionTitle>

      <InputGroup>
        <div>
          <CurrencyInput
            type="text"
            value={customEntryValue}
            onChange={handleEntryChange}
            placeholder="R$ 0,00"
            $hasError={!!entryError}
          />
          {entryError && <InputError>{entryError}</InputError>}
          {!entryError && (
            <InputHelper>
              {validationMessages?.errorMessageMin ||
                `O valor da entrada não pode ser menor que ${formatCurrencyInput(reaisToInputDigits(minEntry))}`}
            </InputHelper>
          )}
        </div>
        <ButtonGroup>
          <SaveButton onClick={handleSaveEntry}>Salvar</SaveButton>
          <CancelButton onClick={handleCancel}>Cancelar</CancelButton>
        </ButtonGroup>
      </InputGroup>

      <DueDate>Vencimento dia {formattedDueDate || '-'}</DueDate>
    </SectionContainer>
  )
}

CustomEntrySection.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  selectedEntry: PropTypes.object,
  minEntryValue: PropTypes.number,
  formattedDueDate: PropTypes.string,
  validationMessages: PropTypes.object
}

CustomEntrySection.defaultProps = {
  selectedEntry: null,
  minEntryValue: 100.0,
  formattedDueDate: '',
  validationMessages: null
}
